'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417 from "./presto.-Dashboard-View$$anon$17.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024 from "./presto.types$-Dashboard-System-Site-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$16() {
  this.aJT = null;
  this.aJL = null;
  this.aJM = false;
  this.aJU = null;
  this.aJV = false;
  this.aJY = null;
  this.aJR = null;
  this.aJS = false;
  this.aJN = null;
  this.aJO = false;
  this.aJP = null;
  this.aJQ = false;
  this.aJW = false;
  this.aJX = false;
  this.aJT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJY = "DashboardSystemSiteStats";
}
export { $c_Lpresto_DashboardView$$anon$16 as $c_Lpresto_DashboardView$$anon$16 };
$p = $c_Lpresto_DashboardView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$16;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$16() {
}
export { $h_Lpresto_DashboardView$$anon$16 as $h_Lpresto_DashboardView$$anon$16 };
$h_Lpresto_DashboardView$$anon$16.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aJT;
});
$p.L = (function() {
  if ((!this.aJM)) {
    this.aJL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJM = true;
  }
  return this.aJL;
});
$p.O = (function() {
  if ((!this.aJV)) {
    this.aJU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJV = true;
  }
  return this.aJU;
});
$p.E = (function() {
  return this.aJY;
});
$p.t = (function() {
  if ((!this.aJS)) {
    this.aJR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJS = true;
  }
  return this.aJR;
});
$p.M = (function() {
  if ((!this.aJO)) {
    this.aJN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().v8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJO = true;
  }
  return this.aJN;
});
$p.Q = (function() {
  if ((!this.aJQ)) {
    this.aJP = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417.$c_Lpresto_DashboardView$$anon$17();
    this.aJQ = true;
  }
  return this.aJP;
});
$p.w = (function() {
  if ((!this.aJX)) {
    this.aJW = false;
    this.aJX = true;
  }
  return this.aJW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee75) => ((p) => \u03b4scrutinee75.cGx(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024.$m_Lpresto_types$DashboardSystemSiteStats$())));
});
var $d_Lpresto_DashboardView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$16, "presto.DashboardView$$anon$16", ({
  GI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$16 as $d_Lpresto_DashboardView$$anon$16 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$16.js.map
